import { useCallback, useMemo } from 'react';

import { ActivityInlineFormProps } from '@/components/activity/ActivityBlockCard';
import Exam from '@/models/Exam';
import ExamArea from '@/models/ExamArea';

import ExamBlockInlineForm, {
  ExamBlockFormFields,
} from './ExamBlockInlineForm';

type ExamBlockEditFormProps = ActivityInlineFormProps & {
  exam: Exam;
  examAreas: ExamArea[];
  examAreaId: number;
};

export default function ExamBlockEditForm({
  activity,
  exam,
  examAreas,
  examAreaId,
  onSubmit,
  onCancel,
  isLoading,
}: ExamBlockEditFormProps) {
  const defaultValues = useMemo(
    () => ({
      name: activity.name,
      examAreaId,
      hasTime: activity.timeLimit !== null,
      timeLimit: activity.timeLimit,
      shuffleQuestions: activity.shuffleQuestions,
    }),
    [activity, examAreaId],
  );

  const handleSubmit = useCallback(
    (data: ExamBlockFormFields) =>
      onSubmit({
        name: data.name,
        timeLimit: data.hasTime ? data.timeLimit : null,
        shuffleQuestions: data.shuffleQuestions,
      }),
    [onSubmit],
  );

  return (
    <ExamBlockInlineForm
      exam={exam}
      examAreas={examAreas}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isLoading={isLoading}
    />
  );
}
